module.exports = __webpack_public_path__ + "media/images/games/35reveal/boat-ab46987a5405d2a67dd48a9c1e506bef.png";